<div
  [matTooltip]="params.value"
  [matTooltipHideDelay]="800"
  matTooltipPosition="right"
  [matTooltipShowDelay]="800"
>
  {{ params.value }}
</div>
